'use client';

import { useEffect } from 'react';
import { trackViewItem } from '@/lib/analytics/ga4';

interface Props {
  product: {
    product_id: number;
    name: string;
    slug?: string;
    category_name?: string;
    base_price?: number | string;
  };
}

export default function PdpTracking({ product }: Props) {
  useEffect(() => {
    trackViewItem(product);
  }, [product.product_id]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
